module.exports = __webpack_public_path__ + "media/images/pages/home-1-e492bd03729cb17cc31f65ebacd47188.jpg";